import AccountMovementsModal from '../../components/AccountMovementsModal/AccountMovementsModal';
import SupplierBillingStatementService from '../../services/SupplierBillingStatementService';
import { PAYMENT_METHOD_LABELS } from '../../components/Reposition/EditReplenishmentModal';

// Cuenta corriente con un proveedor: facturas (cargos), pagos y saldo acumulado.
const SupplierMovementsModal = ({ open, onClose, supplier }) => (
  <AccountMovementsModal
    open={open}
    onClose={onClose}
    subject={supplier}
    subjectName={supplier?.supplierName}
    fetchMovements={(page, pageSize) => SupplierBillingStatementService.getSupplierMovements(supplier.supplierId, page, pageSize)}
    methodLabels={PAYMENT_METHOD_LABELS}
  />
);

export default SupplierMovementsModal;
